const STORAGE_KEY = 'brand_studio_api_key_v1';
const LEGACY_STORAGE_KEY = 'pollinations_api_key_v1';

export function loadRuntimeApiKey() {
  try {
    const current = String(localStorage.getItem(STORAGE_KEY) || '').trim();
    if (current) return current;

    const legacy = String(localStorage.getItem(LEGACY_STORAGE_KEY) || '').trim();
    if (!legacy) return '';

    localStorage.setItem(STORAGE_KEY, legacy);
    localStorage.removeItem(LEGACY_STORAGE_KEY);
    return legacy;
  } catch {
    return '';
  }
}

export function saveRuntimeApiKey(key) {
  try {
    const v = String(key || '').trim();
    if (!v) {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(LEGACY_STORAGE_KEY);
      return;
    }
    localStorage.setItem(STORAGE_KEY, v);
    localStorage.removeItem(LEGACY_STORAGE_KEY);
  } catch {
    // ignore storage failures
  }
}

export function clearRuntimeApiKey() {
  try {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(LEGACY_STORAGE_KEY);
  } catch {
    // ignore
  }
}

